import { Logo } from '@/shared/ui/logo';
import { ThemeToggle } from '@/shared/ui/theme-toggle';

import './auth-layout.css';

import type { ReactNode } from 'react';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className="auth-shell">
      <header className="auth-header">
        <div className="auth-brand">
          <Logo height={24} />
          <span className="auth-residency-label">AI engineering residency</span>
        </div>
        <ThemeToggle />
      </header>
      <section className="auth-entry" aria-label="Your residency account">
        <div className="auth-form-container">{children}</div>
      </section>
      <footer className="auth-footer">Trumio · AI engineering residency</footer>
    </main>
  );
}
